export default "__VITE_ASSET__3a25c7b8__"